module.exports = __webpack_public_path__ + "static/media/top_16.0d8bd918.svg";